<template>
  <a-card :bordered="false">
    <div class="table-page-search-wrapper">
      <a-form layout="inline">
        <a-row :gutter="48">
          <a-col :md="8" :sm="24">
            <a-form-item label="货物名称/编码">
              <a-input v-model.trim="queryParam.materielNameAndCode" placeholder="请输入" />
            </a-form-item>
          </a-col>

          <a-col :md="8" :sm="24">
            <span class="table-page-search-submitButtons">
              <a-button type="primary" @click="$refs.table.refresh(true)">查询</a-button>
              <a-button style="margin-left: 8px" @click="() => queryParam = {}">重置</a-button>
            </span>
          </a-col>
        </a-row>
      </a-form>
    </div>

    <!-- 上部功能导航 -->
    <div class="table-operator">
      <a-button type="primary" icon="plus" @click="handleAdd()">新建</a-button>
    </div>

    <s-table v-if="priceLinkBusiness =='1'"
      ref="table"
      size="default"
      :bordered="config.globlaBordered"
      :rowKey="(record) => record.id"
      :columns="columns"
      :data="loadData"
      :pagination="{pageSizeOptions:pageSizeOptionsList,showTotal:total => `共${total}条`}"
    >
      <span slot="action" slot-scope="text, record">
        
         <a @click="handleInvalid(record)"
            v-if="record.status === '0'"
        >审核</a>
 <a-divider type="vertical" />
         <a @click="handledel(record)"
        >删除</a>
      </span>
    </s-table>

  


     <a-modal title="审核设置" style="top: 100px;" :width="300" v-model="checkvisible" @ok="handleOk">
      <a-form :form="form">
        <a-radio-group @change="onRadioChange" v-model="checkvalue">
          <a-radio :value="1">通过</a-radio>
          <a-radio :value="2">拒绝</a-radio>
        </a-radio-group>
      </a-form>
    </a-modal>
  </a-card>
</template>

<script>
  import { STable } from '@/components'
  import {
    businessTypeList,
    getMaterielPricePage,
    materielPriceDelete,
    materielPriceSave,
    materielList,
    corpBusinessList,
    priceLinkBusiness,
    getMaterielPricedetailPage,
     materielPricedetailSave,
     materielPricedetaildeletedetail
  } from '@/api/basic'
  import moment from 'moment'
  import { getBizTextByValue } from '@/utils/util'
  import { formatDate } from '../../utils/date.js'
  import Bus from '@/layouts/bus'
  import config from '@/config/defaultSettings'

  export default {
    name: 'MaterielPriceList',
    components: {
      STable
    },
    data() {
      return {
        priceLinkBusiness: '',
        pageSizeOptionsList:['10'],
        description:
          '列表使用场景：后台管理中的权限管理以及角色管理，可用于基于 RBAC 设计的角色权限控制，颗粒度细到每一个操作类型。',
        visible: false,
        tvisible: false,
        checkvisible: false,
        checkvalue:1,
          id:null,
            materielId:null,
             customerLevel: null,
            price: null,

        // form: null,
        form: this.$form.createForm(this),
        mdl: {},
        disabled: true,
         
        // 高级搜索 展开/关闭
        advanced: false,
        // 查询参数
        queryParam: {},

        loading: false,
        showLoading: false,
        // 表头
           //{
           // title: '创建人',
          //  dataIndex: 'createId',
           // width: '120px',
         // },
          // {
           // title: '创建时间',
           // dataIndex: 'createTime',
          //  width: '120px',
         // },
          // {
           // title: '审批人',
           // dataIndex: 'approverId',
           // width: '120px',
          //},
          // {
           //title: '审批时间',
            //dataIndex: 'approverTime',
           // width: '120px',
        //  },
        columns: [
          {
            title: '物料名称',
            dataIndex: 'materielName',
            width: '120px'
          },
          {
            title: '物料编码',
            dataIndex: 'materielCode',
            width: '120px'
          },
          {
            title: '客户等级',
            dataIndex: 'customerLevel',
            width: '120px',
            customRender:text =>{
              if(text === '1'){
                return 'A'
              }
              if(text === '2'){
                return 'B'
              }
              if(text === '3'){
                return 'C'
              }
              if(text === '4'){
                return 'D'
              }
            }
          },
          {
            title: '当前价格(元/吨)',
            dataIndex: 'currentPrice',
            width: '120px',
          },
          {
            title: '调整价格(元/吨)',
            dataIndex: 'adjustedPrice',
            width: '120px',
          },

         
          {
            title: '最终价格(元/吨)',
            dataIndex: 'price',
            width: '120px',
          },
           {
            title: '状态',
            dataIndex: 'status',
            width: '120px',
            customRender: text =>{
              if(text === '0'){
                return '待审核'
              }
               if(text === '1'){
                return '审核通过'
              }
               if(text === '2'){
                return '审核拒绝'
              }
            }
            
          },
          {
            title: '操作',
            dataIndex: 'action',
            width: '120px',
            scopedSlots: { customRender: 'action' }
          }
        ],

        // 表头
        columns2: [
          {
            title: '物料名称',
            dataIndex: 'materielName',
            width: '120px'
          },
          {
            title: '物料编码',
            dataIndex: 'materielCode',
            width: '120px'
          },
          {
            title: '价格(元/吨)',
            dataIndex: 'price',
            width: '120px',
          },
          {
            title: '操作',
            dataIndex: 'action',
            width: '120px',
            scopedSlots: { customRender: 'action' }
          }
        ],
        // 加载数据方法 必须为 Promise 对象
        loadData: parameter => {
          return getMaterielPricedetailPage(Object.assign(parameter, this.queryParam)).then(res => {
            return res.data
          })
        },

        selectedRowKeys: [],
        selectedRows: [],

        // 业务类型
        businessSelect: null,
        materielSelect: null,
        levelSelect:null,

      }
    },
    created() {
      this.tableOption()
      this.loadSelectData()
    },
    methods: {
      moment,
      loadSelectData() {
        // 从后台拉取下拉列表数据
        this.levelSelect = this.$store.getters.codeList.basic_corp_level
        new Promise(resolve => {
          const data = materielList().then(res => {
            return res.data
          })
          resolve(data)
        }).then(res => {
          this.materielSelect = res
        })
        new Promise(resolve => {
          const data = corpBusinessList().then(res => {
            return res.data
          })
          resolve(data)
        }).then(res => {
          this.businessSelect = res
        })

        
        new Promise(resolve => {

          const data = priceLinkBusiness().then(res => {
            return res.data
          })
          resolve(data)
        }).then(res => {
          this.priceLinkBusiness = res.priceLinkBusiness
          this.$forceUpdate()
        })

      },
  onRadioChange(e) {
       console.log('radio checked', e.target.value)
    },

      tableOption() {
        if (!this.optionAlertShow) {
          this.options = {
            alert: {
              show: false,
              clear: () => {
                this.selectedRowKeys = []
              }
            },
            rowSelection: {
              selectedRowKeys: this.selectedRowKeys,
              onChange: this.onSelectChange
            }
          }
          this.optionAlertShow = true
        } else {
          this.options = {
            alert: false,
            rowSelection: null
          }
          this.optionAlertShow = false
        }
      },
      handleInvalid(record) {
          this.checkvisible= true
           this.id = record.id
            this.materielId = record.materielId
             this.customerLevel = record.customerLevel
              this.price = record.price
      },
      handledel(record) {
        var nthis = this
        this.$confirm({
          title: '提示',
          content: '确定要删除吗?',
          onOk() {
            nthis.confirmLoading = true
            return materielPricedetaildeletedetail(Object.assign({}, { id: record.id})).then(res => {
                if (res.code === '0') {
                 nthis.$refs.table.refresh()
                }
              })
              .catch(e => {
                console.log(e)
              })
              .finally(() => {
                nthis.confirmLoading = false
              })
          },
          onCancel() {}
        })
      },
      handleOk() {
          materielPricedetailSave(Object.assign({}, { id: this.id, materielId: this.materielId, customerLevel: this.customerLevel, price: this.price, status: this.checkvalue }))
        .then(res => {
          if (res.code === '0') {
            this.$refs.table.refresh()
          }
        })
        .catch(() => {})
        .finally(() => {
          this.checkvisible = false
        })
      },

      onChange(selectedRowKeys, selectedRows) {
        this.selectedRowKeys = selectedRowKeys
        this.selectedRows = selectedRows
      },
      toggleAdvanced() {
        this.advanced = !this.advanced
      },
    },
    watch: {
    }
  }
</script>

<style scoped>
  /deep/ .ant-form-item {
    margin-bottom: 10px;
  }
</style>